import { Checkbox } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const AttributeDefinitionSectionConfiguration: FunctionComponent = observer(() => {
	const { 
		attrDisableDragEdits,
		attrEnableComments,
		attrEnabled,
		attrHidden,
		attrReadonly,
		attrRequired,
		attrSubtypeConfiguration,
		attrUOMEnabled,
		locale,
		onChangeDisableDragEdits,
		onChangeEnableComments,
		onChangeEnabled,
		onChangeHidden,
		onChangeReadonly,
		onChangeRequired,
		onChangeSubtypeConfiguration,
	} = useAttributeDefinitionStore();

	const {
		helperTextHiddenRes,
		helperTextReadonlyRes,
		helperTextRequiredRes,
		helperTextSubtypeConfigurationRes,
		labelDisableDragEditsRes,
		labelEnableCommentsRes,
		labelEnabledRes,
		labelHiddenRes,
		labelReadonlyRes,
		labelRequiredRes,
		labelSubtypeConfigurationRes,
	} = locale;
	
	return (
		<>
			<Checkbox
				ariaLabelRes={labelEnabledRes}
				checked={attrEnabled}
				labelRes={labelEnabledRes}
				onChange={onChangeEnabled}
			/>
			{!attrUOMEnabled && (
				<Checkbox
					ariaLabelRes={labelRequiredRes}
					checked={attrRequired}
					helperTextRes={helperTextRequiredRes}
					labelRes={labelRequiredRes}
					onChange={onChangeRequired}
				/>
			)}
			<Checkbox
				ariaLabelRes={labelSubtypeConfigurationRes}
				checked={attrSubtypeConfiguration}
				helperTextRes={helperTextSubtypeConfigurationRes}
				labelRes={labelSubtypeConfigurationRes}
				onChange={onChangeSubtypeConfiguration}
			/>
			{!attrUOMEnabled && (
				<Checkbox
					ariaLabelRes={labelReadonlyRes}
					checked={attrReadonly}
					helperTextRes={helperTextReadonlyRes}
					labelRes={labelReadonlyRes}
					onChange={onChangeReadonly}
				/>
			)}
			<Checkbox
				ariaLabelRes={labelDisableDragEditsRes}
				checked={attrDisableDragEdits}
				labelRes={labelDisableDragEditsRes}
				onChange={onChangeDisableDragEdits}
			/>
			<Checkbox
				ariaLabelRes={labelEnableCommentsRes}
				checked={attrEnableComments}
				labelRes={labelEnableCommentsRes}
				onChange={onChangeEnableComments}
			/>
			{!attrUOMEnabled && (
				<Checkbox
					ariaLabelRes={labelHiddenRes}
					checked={attrHidden}
					helperTextRes={helperTextHiddenRes}
					labelRes={labelHiddenRes}
					onChange={onChangeHidden}
				/>
			)}
		</>
	);
});

export default AttributeDefinitionSectionConfiguration;